module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-spring-698d8eafa199957adf3ad4ad8f3baad0.jpeg";